export const getDiscount = (
  premiumAndDelta: string,
  premiumAndDeltaPromo: string
) =>
  Math.round(
    (1 - Number(premiumAndDeltaPromo) / Number(premiumAndDelta)) * 100
  );
